import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Smile: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  d = 'M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v4l4-4h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-5 3.75A1.25 1.25 0 1 1 11.75 5 1.25 1.25 0 0 1 13 3.75zm-6 0A1.25 1.25 0 1 1 5.75 5 1.25 1.25 0 0 1 7 3.75zM10 12a5 5 0 0 1-4.58-3h9.16A5 5 0 0 1 10 12z',
  viewBox = '0 0 20 20',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullWidthStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default Smile;
